var f = (s, r, e) => new Promise((n, t) => {
  var o = (l) => {
    try {
      i(e.next(l));
    } catch (d) {
      t(d);
    }
  }, c = (l) => {
    try {
      i(e.throw(l));
    } catch (d) {
      t(d);
    }
  }, i = (l) => l.done ? n(l.value) : Promise.resolve(l.value).then(o, c);
  i((e = e.apply(s, r)).next());
});
import { jsx as a, Fragment as u } from "react/jsx-runtime";
import { createContext as m, useState as w, useContext as h } from "react";
const v = {
  isAllowedTo: () => Promise.resolve(!1)
}, P = m(v), T = ({
  fetchPermission: s,
  children: r
}) => {
  const e = {}, n = (t) => f(void 0, null, function* () {
    if (Object.keys(e).includes(t))
      return e[t];
    const o = yield s(t);
    return e[t] = o, o;
  });
  return /* @__PURE__ */ a(P.Provider, { value: { isAllowedTo: n }, children: r });
}, x = (s) => {
  const [r, e] = w(!0), [n, t] = w(), { isAllowedTo: o } = h(P);
  return o(s).then((c) => {
    e(!1), t(c);
  }), [r, n];
}, j = ({
  to: s,
  fallback: r,
  loadingComponent: e,
  children: n
}) => {
  const [t, o] = x(s);
  return t ? /* @__PURE__ */ a(u, { children: e }) : o ? /* @__PURE__ */ a(u, { children: n }) : /* @__PURE__ */ a(u, { children: r });
};
export {
  P,
  j as R,
  T as a,
  x as u
};
